import { useDispatch } from "react-redux";
import { addItem } from "../redux/slices/cartSlice";
import { getDataFromLocalStorage } from "../utils/orderStorage";

export function useLocalStorageOrder() {
  const dispatch = useDispatch();
  const orderList = getDataFromLocalStorage("currentOrder");

  if (!orderList || orderList.length === 0) {
    return;
  }

  orderList.forEach((product) => {
    dispatch(addItem({ ...product }));
  });
}
